var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStopShareScreen(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 57,
    viewBox: "0 0 57 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 28.5,
    cy: 28.5,
    r: 28.5,
    fill: "#5B5A5A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39 22.92V31.09C39 34.62 36.729 37 33.34 37H24.67C21.28 37 19 34.62 19 31.09V22.92C19 19.38 21.28 17 24.67 17H33.34C36.729 17 39 19.38 39 22.92ZM28.25 24.73V31.08C28.25 31.5 28.59 31.83 29 31.83C29.42 31.83 29.75 31.5 29.75 31.08V24.73L32.22 27.21C32.36 27.35 32.56 27.43 32.75 27.43C32.939 27.43 33.13 27.35 33.28 27.21C33.57 26.92 33.57 26.44 33.28 26.15L29.53 22.38C29.25 22.1 28.75 22.1 28.47 22.38L24.72 26.15C24.43 26.44 24.43 26.92 24.72 27.21C25.02 27.5 25.49 27.5 25.79 27.21L28.25 24.73Z",
    fill: "#66A5EF"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStopShareScreen);
export default __webpack_public_path__ + "static/media/stop_share_screen.e94965c5b1d686acc0425bd0dfa00420.svg";
export { ForwardRef as ReactComponent };